const Profile = {
  page_title: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.page_title;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'page_title', payload });
    },
  },
  facebook: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.facebook;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'facebook', payload });
    },
  },
  twitter: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.twitter;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'twitter', payload });
    },
  },
  google: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.google;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'google', payload });
    },
  },
  instagram: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.instagram;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'instagram', payload });
    },
  },
  terms_conditions: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.terms_conditions;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'terms_conditions', payload });
    },
  },
  return_policy: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.return_policy;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'return_policy', payload });
    },
  },
  about_us: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.about_us;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'about_us', payload });
    },
  },
  privacy_policy: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.privacy_policy;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'privacy_policy', payload });
    },
  },
  email_support: {
    get() {
      return this.$store.state.SettingsModule.Config.profile.profile.email_support;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProfileProperty', { property: 'email_support', payload });
    },
  },
  care_lines() {
    return this.$store.state.SettingsModule.Config.profile.profile.care_lines || [];
  },
};

export default Profile;
